module.exports = __webpack_public_path__ + "img/RWBuikd Code Summit 2022 Group.5be29590.png";